import React, { useRef, forwardRef } from "react";
import clsx from "clsx";
import { Button, CheckboxField, Form, MenuItem, SelectField, TextField } from "@curves/ui-base";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { isEmpty, isFunction, refIsRequiredError } from "@util/utils";
import { EmployeeSelect } from "@icoach/components";
import useOptions from "@util/hook/useOptions";
import useMemberDiscardRecordApi from "@apis/useMemberDiscardRecordApi";

const InactiveMemberNotificationStopDialog = forwardRef(({ className, open, sourceData, onClose, refresh }, ref) => {
	if (!open) return null;
	const { getMemberDiscardRecordOptionsApi, postMemberDiscardRecordStopSMSApi } = useMemberDiscardRecordApi();

	const { options } = useOptions({
		getOptionsApi: getMemberDiscardRecordOptionsApi,
		isFetchOnMount: true,
	});
	const { employeeOption, discardRecordReasonOption } = options || {};

	const formRef = useRef({});
	const confirmRef = useRef(null);

	const doPostMemberDiscardRecordStopSMS = async params => {
		try {
			let resp = await postMemberDiscardRecordStopSMSApi(params);
			if (resp) {
				isFunction(refresh) && refresh(resp);
				isFunction(onClose) && onClose();
			}
		} catch (error) {
			console.error("Error stopping member notification:", error);
		}
	};

	const handleSubmit = () => {
		let isError = refIsRequiredError(formRef);
		if (!isError) {
			const params = {
				memberID: sourceData.memberID,
				employeeID: formRef.current.emloyeeID.getResult(),
				reason: formRef.current.reason.getResult() || 0,
				notes: formRef.current.notes.getResult() || "",
			};
			doPostMemberDiscardRecordStopSMS(params);
		}
	};

	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-40rem", component: Form }} onSubmit={handleSubmit} open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>停止接收通知</GradientColorHeader>
			<DialogContent>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<EmployeeSelect label="經辦教練" ref={el => (formRef.current.emloyeeID = el)} options={employeeOption} fullWidth required />
					</Grid>
					<Grid item xs={12}>
						<SelectField label="原因" ref={el => (formRef.current.reason = el)} displayEmpty fullWidth required>
							{!isEmpty(discardRecordReasonOption) &&
								discardRecordReasonOption
									.filter(item => item || !item.disabled)
									.map(item => (
										<MenuItem key={item.value} value={item.value}>
											{item.text}
										</MenuItem>
									))}
						</SelectField>
					</Grid>
					<Grid item xs={12}>
						<TextField label="備註" ref={el => (formRef.current.notes = el)} InputProps={{ placeholder: "請輸入" }} rows="4" multiline fullWidth />
					</Grid>
					<Grid item xs={12}>
						<CheckboxField ref={confirmRef}>
							<CheckboxField.Checkbox label="我已了解送出後將清除會員聯絡資訊且無法復原。" value="1" required />
						</CheckboxField>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button type={"submit"} variant="contained">
					確認送出
				</Button>
			</DialogActions>
		</Dialog>
	);
});

export default InactiveMemberNotificationStopDialog;
